import React from 'react';
import { Navigate, useLocation } from 'react-router';
import Search from '../views/search/Search';
import { canonicalYardsPath } from '../hooks/search/useLocationSearchParams';

/**
 * The search page at /yards and /yards/<country>/<state>/<city> (securspace-ui#3052).
 * Another spelling of a city path (case, trailing slash, punctuation) moves to the
 * lowercase one, and any other /yards/* shape to /yards; the query rides along.
 */
const YardsSearch = () => {
  const { pathname, search, hash } = useLocation();
  const canonical = canonicalYardsPath(pathname);
  return canonical === pathname ? <Search /> : <Navigate replace to={{ pathname: canonical, search, hash }} />;
};

export default YardsSearch;
